import React, { useState } from "react";
import { Alert, Button, Stack, Typography } from "@mui/material";
import MarkEmailUnreadOutlinedIcon from "@mui/icons-material/MarkEmailUnreadOutlined";
import { sendEmailVerification } from "firebase/auth";
import { useNavigate } from "react-router-dom";
import { auth, authErrorMessage } from "../firebase";
import { endSession } from "../session";
import AuthLayout from "./AuthLayout";

// Las cuentas con email y contraseña tienen que verificar el email antes de usar la app
const VerifyEmail = () => {
  const navigate = useNavigate();
  const [message, setMessage] = useState(null);
  const [busy, setBusy] = useState(false);
  const email = auth.currentUser?.email;

  const run = async (action) => {
    setBusy(true);
    setMessage(null);
    try {
      await action();
    } catch (error) {
      setMessage({ severity: "error", text: authErrorMessage(error) });
    } finally {
      setBusy(false);
    }
  };

  const checkVerified = () =>
    run(async () => {
      await auth.currentUser.reload();
      // El token se renueva para que las reglas de Firestore vean el email verificado
      await auth.currentUser.getIdToken(true);
      if (auth.currentUser.emailVerified) {
        window.location.assign("/home");
      } else {
        setMessage({ severity: "warning", text: "Todavía no verificaste tu email. Revisá tu bandeja de entrada y spam." });
      }
    });

  const resend = () =>
    run(async () => {
      await sendEmailVerification(auth.currentUser);
      setMessage({ severity: "success", text: `Te reenviamos el email a ${email}.` });
    });

  const logout = () =>
    run(async () => {
      await endSession();
      navigate("/login");
    });

  return (
    <AuthLayout title="Verificá tu email" subtitle={`Te enviamos un enlace a ${email}.`}>
      <Stack spacing={2} sx={{ mt: 2 }}>
        <Stack direction="row" spacing={1.5} alignItems="flex-start" sx={{ color: "text.secondary" }}>
          <MarkEmailUnreadOutlinedIcon sx={{ color: "secondary.dark" }} />
          <Typography variant="body2">
            Abrí el email, tocá el enlace de verificación y después volvé acá y tocá «Ya verifiqué».
          </Typography>
        </Stack>
        {message && <Alert severity={message.severity}>{message.text}</Alert>}
        <Button variant="contained" color="secondary" size="large" onClick={checkVerified} disabled={busy}>
          Ya verifiqué
        </Button>
        <Button variant="outlined" color="inherit" onClick={resend} disabled={busy}>
          Reenviar email
        </Button>
        <Button color="inherit" onClick={logout} disabled={busy}>
          Usar otra cuenta
        </Button>
      </Stack>
    </AuthLayout>
  );
};

export default VerifyEmail;
